import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './containers/index';
import reportWebVitals from './reportWebVitals';
import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider } from 'antd';
// Provider
import QueryProvider from './QueryProvider';
import AuthProvider from './authService/AuthProvider';
// Theme
import loopiTheme from './theme/antdTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={loopiTheme}>
      <AuthProvider>
        <QueryProvider>
          <App />
        </QueryProvider>
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
